module.exports = __webpack_public_path__ + "static/contentless-3b9729b3b2a5fa1cc666233a4e49b5b7.png";